// extracted by mini-css-extract-plugin
export default {"inputsWrapper":"RangeFilterInputs_inputsWrapper__wF+II"};